import { splitCallByChunksAndAggregateResult } from '../helpers'
import { getHub } from '../../helpers/hub'
import { Security } from '../securities/reducer'

const GET_SECURITIES_IDS_FROM_IDENTIFIERS_CHUNK_SIZE = 1000
export const getSecurityIdsFromIdentifier$ = (identifiers: string[]) =>
  splitCallByChunksAndAggregateResult(
    identifiers,
    GET_SECURITIES_IDS_FROM_IDENTIFIERS_CHUNK_SIZE,
    (identifiersChunk) =>
      // an identifier could have multiple security id's, hence an array of arrays
      getHub().invoke<Array<Array<Security['id']>>>(
        'GetSecurityIds',
        identifiersChunk
      )
  )
